exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".study-list__action-buttons{display:grid;width:100%;grid-template-columns:20% 20% auto;grid-column-gap:.5rem;grid-row-gap:.5rem}.study-list__action-buttons__inference{grid-column:3}", ""]);

